//
// formatString
//
// Strings contains substrings formatted as '?0?', '?1?', etc....
// Replace them with corresponding params array item
//
// Second version:
//
// Strings contains substring formatted as '%{argname}'
// Replace with argname property found in params object
//

const formatString = (text, params) => {
  if (!params) return text;

  if (Array.isArray(params)) {
    let retString = text;

    params.forEach((param, index) => {
      retString = retString.replace(`?${index}?`, param);
    });
    return retString;
  }

  if (params && (typeof params !== 'string')) {
    const regexp = /%{[A-Za-z0-9]{2,45}}/g;
    const argsList = [...text.matchAll(regexp)];
    let retString = text;
    // console.log(`text="${text}", argsList=${argsList}, params=${JSON.stringify(params)}`);

    argsList.forEach((arg) => {
      // console.log(`arg="${arg.toString()}", type="${typeof arg.toString()}"`);
      const argString = arg.toString().replace('%{', '').replace('}', '');
      // console.log(`argString="${argString}", type="${typeof argString}"`);
      const argToReplace = `%{${argString}}`;
      let replaceWith = params[argString];
      if (replaceWith === undefined) replaceWith = '-undefined-';
      // console.log(`argString="${argString}", argToReplace="${
      //   argToReplace}", replaceWith="${replaceWith}"`);

      retString = retString.replace(argToReplace, replaceWith);
      // console.log(`retString="${retString}"`);
    });

    return retString;
  }

  return text.replace('?0?', params);
};

export default formatString;
